import React, {Component} from 'react';
import Recipient from "./Recipient";

class Recipients extends Component {

    constructor(props) {
        super(props);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.handleRemoveRow = this.handleRemoveRow.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleScopeChange = this.handleScopeChange.bind(this);
        this.handleDraggedElementNameChange = this.handleDraggedElementNameChange.bind(this);
        this.handleAccessCode = this.handleAccessCode.bind(this);
        this.handleIsRequesterChange = this.handleIsRequesterChange.bind(this);
        this.orderValueChange = this.orderValueChange.bind(this);
        this.moveUp = this.moveUp.bind(this)
        this.moveDown = this.moveDown.bind(this)
    }

    moveUp(index){
        this.props.moveUp(index);
    }
    moveDown(index){
        this.props.moveDown(index);
    }
    handleAddRow() {
        this.props.onAddRow();
    }

    handleRemoveRow(index) {
        this.props.onRemoveRow(index);
    }

    orderValueChange(index, value){
        this.props.onOrderValueChange(index, value);
    }
    handleNameChange(index, value) {
        this.props.onRecipientNameChange(index, value);
    }
    handleAccessCode(index, value) {
        this.props.onRecipientAccessCodeChange(index, value);
    }

    handleEmailChange(index, value) {
        this.props.onRecipientEmailChange(index, value);
    }

    handleScopeChange(index, value) {
        this.props.onRecipientScopeChange(index, value);
    }

    handleDraggedElementNameChange(event,index) {
        this.props.onRecipientElementNameChange(event, index);
    }
    handleIsRequesterChange(index, event){
        this.props.onRecipientIsRequesterChange(index, event);
    }

    render() {
        let _this = this;
        const recipients = _this.props.recipients.map((recipient, index) => {
            return <Recipient recipient={recipient} key={index}
                              onNameChange={_this.handleNameChange}
                              onEmailChange={_this.handleEmailChange}
                              onScopeChange={_this.handleScopeChange}
                              onRemoveRow={_this.handleRemoveRow}
                              accessCodeChange={_this.handleAccessCode}
                              onElementNameChange = {_this.handleDraggedElementNameChange}
                              onIsRequesterChange = {_this.handleIsRequesterChange}
                              selectedTemplateElementName={recipient.selectedTemplateElementNameByRecipient}
                              enableSigningOrder = {_this.props.enableSigningOrder}
                              orderValueChange = {_this.orderValueChange}
                              moveUp = {this.moveUp}
                              moveDown = {this.moveDown}
            />
        });

        return (

            <div className="form-group" style={{marginBottom:"5px"}}>
                <label className="col-lg-2 control-label">{_this.props.msg('form.label.signerAndCCs')}</label>
                <div className="col-lg-10">
                    {recipients}
                </div>

            </div>

        )
    }
}

export default Recipients;



// WEBPACK FOOTER //
// ./src/components/template/Recipients.js